<style scoped>
    .spinner {
        display: block;
        background-position-y: 150px;
    }
    .tfs4jira-mapping-table {
        display: table;
    }
    .mapping-no-mapped-values-container {
        text-align: center;
        margin-bottom: 50px;
    }
    .links-notification {
        margin-bottom: 3em;
    }
</style>
<template>
    <div>
        <div class="tfs4jira-mapping-container">
            <div v-show="hierarchy && hierarchy.Enabled" class="links-notification">
                <notification class="info" icon-name="info-circle" icon-class="info-message">
                    <p>
                        Please note that links used in
                        <span v-if="wizardView">Hierarchy Mapping</span>
                        <a v-else :href="`${contextPath}/Tfs/Index/${profileGuid}?mappings=1&hierarchy=1`">
                            Hierarchy Mapping
                        </a>
                        are not available here.
                    </p>
                </notification>
            </div>
            <mapping-selects
                :jiraSelectTitle="jiraSelectTitle"
                :tfsSelectTitle="tfsSelectTitle">
            </mapping-selects>
            <div class="mapping-no-mapped-values-container" v-show="(mappings && mappings.length == 0)">
                <span class="tfs4jira-mapping-no-mapped-values">
                    Please select Jira and TFS link types that you want to map.
                </span>
            </div>
            <table class="tfs4jira-mapping-table">
                <tbody>
                    <mapping-row
                        v-for="row in mappings"
                        :key="row.Id"
                        :mapping="row"
                        :isLinksMapping="true">
                    </mapping-row>
                </tbody>
            </table>
        </div>
        <div class="spinner" v-show="isLoaderVisible"></div>
    </div>
</template>
<script>
    import MappingSelects from './mappings/MappingSelects';
    import MappingRow from './mappings/MappingRow'
    import { mapGetters, mapActions } from 'vuex';
    import { NAMESPACE as APP_NAMESPACE } from '../store/modules/app.js';
    import Notification from './Notification';
    import { NAMESPACE as MAPPINGS_NAMESPACE } from '../store/modules/mappings.js';
    import LinksService from './../service/links.js';
    import axios from 'axios';

    export default {
        props: [
            'profileGuid',
            'loadOnInit',
            'wizardView'
        ],
        data() {
            return {
                jiraSelectTitle: 'Jira Link Types',
                tfsSelectTitle: 'TFS Link Types',
                hierarchy: {},
                mountCallback: function(){} // its for unit tests purposes
            }
        },
        computed: mapGetters({
            mappings: MAPPINGS_NAMESPACE.getters.MAPPINGS,
            isLoaderVisible: MAPPINGS_NAMESPACE.getters.IS_LOADER_VISIBLE,
            contextPath: APP_NAMESPACE.getters.CONTEXT_PATH,
            imagePath: APP_NAMESPACE.getters.IMAGE_PATH
        }),
        methods: {
            ...mapActions({
                setUpService: MAPPINGS_NAMESPACE.actions.SET_UP_SERVICE,
                getAvailableValues: MAPPINGS_NAMESPACE.actions.GET_AVAILABLE_VALUES,
                registerListener: APP_NAMESPACE.actions.ADD_LISTENER
            }),
            initComponent: async function()  {
                this.setUpService({
                    prefix: this.contextPath + '/api/profiles/' + this.profileGuid,
                    service: new LinksService(axios)
                });

                let dataFromApi = await this.getAvailableValues();
                if(dataFromApi != null) {
                    this.hierarchy = dataFromApi.hierarchy;
                }
                this.mountCallback();
            }
        },
        components: {
            MappingSelects,
            MappingRow,
            Notification
        },
        mounted: function() {
            if (this.loadOnInit !== undefined && this.loadOnInit === 'true') {
                this.initComponent();
            }
            this.registerListener({
                on: 'RefreshLinkMappingComponent',
                handler: function(notification) {
                    this.initComponent();
                }.bind(this)
            });
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/LinkMapping.vue